(function(){
  function ready(fn){document.readyState==='loading'?document.addEventListener('DOMContentLoaded',fn):fn();}

  function injectStyles(){
    if(document.getElementById('norpat-product-fullwidth-description-css')) return;
    var style=document.createElement('style');
    style.id='norpat-product-fullwidth-description-css';
    style.textContent=[
      '.template-product .norpat-product-description-fullwrap{clear:both;width:100%;margin:56px auto 0;padding:0;}',
      '.template-product .norpat-product-description-fullwrap .product-description{display:block!important;float:none!important;width:100%!important;max-width:1120px!important;margin:0 auto!important;padding:0 24px!important;box-sizing:border-box;}',
      '.template-product .norpat-product-description-fullwrap .product-description img{max-width:100%!important;height:auto!important;}',
      '.template-product .norpat-product-description-fullwrap .product-description iframe,.template-product .norpat-product-description-fullwrap .product-description video{max-width:100%!important;}',
      '.template-product .norpat-product-description-fullwrap .product-description table{max-width:100%;}',
      '@media(max-width:749px){.template-product .norpat-product-description-fullwrap{margin-top:36px;}.template-product .norpat-product-description-fullwrap .product-description{padding:0 16px!important;}}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function moveDescription(){
    var root=document.querySelector('[data-section-type="product"]');
    if(!root) return;
    var wrapper=root.querySelector('.product-wrapper');
    var details=root.querySelector('.product-details');
    if(!wrapper||!details) return;
    var desc=details.querySelector('#product-description.product-description, .product-description');
    if(!desc||desc.getAttribute('data-norpat-fullwidth-description')==='1') return;
    if(!desc.textContent.trim()&&!desc.querySelector('img,iframe,video,table')) return;
    var fullwrap=document.createElement('div');
    fullwrap.className='norpat-product-description-fullwrap';
    fullwrap.setAttribute('data-norpat-fullwidth-description-wrap','1');
    desc.setAttribute('data-norpat-fullwidth-description','1');
    fullwrap.appendChild(desc);
    if(wrapper.nextSibling){root.insertBefore(fullwrap,wrapper.nextSibling);}else{root.appendChild(fullwrap);}
  }

  ready(function(){injectStyles();moveDescription();});
  document.addEventListener('shopify:section:load',function(){injectStyles();moveDescription();});
})();
